import jsPDF from 'jspdf';

import html2canvas from 'html2canvas';
import firmaRamiro from '../imagenes/firma_ramiro_merida.png'
import firmaCarlos from '../imagenes/firma_carlos_ajpop.jpg'
import firmaJorge from '../imagenes/firma_jorge_martinez.jpg'
import firmaAngely from '../imagenes/firma_angelly_villagran.png'


export const GenerarPDF = async ({ barraRef0, barraRef1, barraRef2, barraRef3, fechaInicio, fechaFin, conteo, media2, mediana, moda, desviacionEstandar, coeficienteVariacion, data, rango, rango_bajo, rango_alto }) => {

       
    
    const pdf = new jsPDF('p', 'mm', 'letter');

    if (!barraRef0?.current) {
        console.warn('Gráfico no disponible para exportar');
        return;
    }


    pdf.setFontSize(12);

    const pageWidth = pdf.internal.pageSize.getWidth();
    pdf.setFont('helvetica', 'bold');
    const titulo1 = 'CARTA CONTROL';
    const titulo2 = 'MONITOREO DE PRODUCTO ENSACADO NUTRAMIX';

    // Centrado dinámico
    const x1 = (pageWidth - pdf.getTextWidth(titulo1)) / 2;
    const x2 = (pageWidth - pdf.getTextWidth(titulo2)) / 2;

    pdf.text(titulo1, x1, 10); // Primera línea
    pdf.text(titulo2, x2, 15); // Segunda línea, 10mm más abajo

    pdf.setFontSize(10);

    // Negrita para "Producto:"
    pdf.setFont('helvetica', 'bold');
    pdf.text('Producto:', 20, 25);


    // Normal para "Engordamix"
    pdf.setFont('helvetica', 'normal');
    const espacio = 2; // espacio manual entre textos
    const xEngordamix = 20 + pdf.getTextWidth('Producto: ') + espacio;
    pdf.text(data[0].producto, xEngordamix, 25);

    pdf.setFontSize(10);

    // Negrita para "Producto:"
    pdf.setFont('helvetica', 'bold');
    pdf.text('Ticket:', 20, 30);

    // Normal para "Engordamix"
    pdf.setFont('helvetica', 'normal');
    const espacio2 = 2; // espacio manual entre textos
    const NoTicket = 20 + pdf.getTextWidth('Ticket: ') + espacio2;
    pdf.text(data[0].no_lote, NoTicket, 30);



    pdf.setFontSize(10);
    // Negrita para "Producto:"
    pdf.setFont('helvetica', 'bold');
    pdf.text('Fecha:', 20, 35);

    // Normal para "Engordamix"
    pdf.setFont('helvetica', 'normal');
    const espacio3 = 2; // espacio manual entre textos
    const Fecha = 10 + pdf.getTextWidth('Fecha Inicio: ') + espacio3;
    //pdf.text(data[0].fecha_hora_inicio, Fecha, 30);
 
    const fecha = new Date(fechaInicio);
    const dia = String(fecha.getDate() + 1).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const año = String(fecha.getFullYear());

    const fechaFormateada = `${dia}/${mes}/${año}`;
    
    pdf.text(fechaFormateada, Fecha, 35);

    pdf.setFontSize(10);
    // Negrita para "Producto:"
    pdf.setFont('helvetica', 'bold');
   // pdf.text('Fecha Fin: ', 20, 35);

    // Normal para "Engordamix"
    pdf.setFont('helvetica', 'normal');
    const espacio4 = 2; // espacio manual entre textos
    const Hora = 20 + pdf.getTextWidth('Fecha Fin: ') + espacio4;
    //pdf.text(data[0].fecha_hora_fin, Hora, 35);

     const fechaF = new Date(fechaFin); // o cualquier fecha válida

    const diaFin = String(fechaF.getDate()+1).padStart(2, '0');
    const mesFin = String(fechaF.getMonth() + 1).padStart(2, '0'); // +1 porque los meses van de 0 a 11
    const añoFin = fechaF.getFullYear();

    const formateadaFin = `${diaFin}/${mesFin}/${añoFin}`;


    //pdf.text(formateadaFin, Fecha, 35);

    //pdf.text(fechaFin, Hora, 35);


    pdf.setFontSize(10);
    // Negrita para "Producto:"
    pdf.setFont('helvetica', 'bold');
    pdf.text('Responsables:', 20, 40);

    // Normal para "Engordamix"
    pdf.setFont('helvetica', 'normal');
    const espacio5 = 2; // espacio manual entre textos
    const Responsables = 20 + pdf.getTextWidth('Responsables: ') + espacio5
    pdf.text(data[0].responsable, Responsables, 40);


    pdf.setFontSize(10);
    // Negrita para "Producto:"
    pdf.setFont('helvetica', 'bold');
    pdf.text('Grafica No. 1', 20, 50);

    // Normal para "Engordamix"
    pdf.setFont('helvetica', 'normal');
    const espacio6 = 2; // espacio manual entre textos
    const Grafica1 = 20 + pdf.getTextWidth('Grafica No. 1: ') + espacio6
    pdf.text('Verificación de pesos en dos batch de producto terminado al azar.', Grafica1, 50);


    const canvas = await html2canvas(barraRef0.current);
    const imgData = canvas.toDataURL('image/png');
    pdf.addImage(imgData, 'PNG', -40, 52, 300, 90);

    pdf.setFontSize(10);
    // Negrita para "Producto:"
    pdf.setFont('helvetica', 'bold');
    pdf.text('Grafica No. 2', 20, 148);

    // Normal para "Engordamix"
    pdf.setFont('helvetica', 'normal');
    const espacio7 = 2; // espacio manual entre textos
    const Grafica2 = 20 + pdf.getTextWidth('Grafica No. 2: ') + espacio7
    pdf.text('Verificación de frecuencia de pesos en dos batch de producto terminado al azar.', Grafica2, 148);


    const canvas1 = await html2canvas(barraRef1.current);
    const imgData1 = canvas1.toDataURL('image/png');
    pdf.addImage(imgData1, 'PNG', -40, 152, 300, 90);



    pdf.addPage();


    pdf.setFontSize(10);
    // Negrita para "Producto:"
    pdf.setFont('helvetica', 'bold');
    pdf.text('Cuadro No. 1', 20, 10);

    // Normal para "Engordamix"
    pdf.setFont('helvetica', 'normal');
    const espacio8 = 2; // espacio manual entre textos
    const Cudaro1 = 20 + pdf.getTextWidth('Cuadro No. 1: ') + espacio8
    pdf.text(' Resumen de pesos de acuerdo a los parámetros asignados, verificados en dos batch de', Cudaro1, 10);
    pdf.setFont('helvetica', 'normal');
    const espacio9 = 20; // espacio manual entre textos
    const Cudaro2 = 11 + pdf.getTextWidth('              ') + espacio9
    pdf.text('  producto terminado.', Cudaro2, 15);


    //pdf.setLineWidth(0.5);
    //pdf.line(20, 40, 200, 70);

    const canvas2 = await html2canvas(barraRef2.current);
    const imgData2 = canvas2.toDataURL('image/png');
    pdf.addImage(imgData2, 'PNG', -10, 20, 250, 50);

    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');

    const texto = `En el monitoreo de pesos de producto terminado, ${data[0].producto} con ticket: ${data[0].no_lote} en 
presentación ensacado, se verificaron ${rango_bajo + rango_alto + rango} sacos al azar de dicho producto, para determinar si 
cumplen con los pesos en los límites asignados en la carta control, tal como se describe a 
continuación: límite superior es de 45.7 y el límite inferior de 45.4 
De acuerdo al cuadro No. 1, se puede apreciar que el ${rango_bajo + rango_alto}% de los sacos no cumplen con el peso, ya 
que es menor o mayor en lo requerido por la carta control, entre estos datos el ${rango_bajo}% están por 
debajo del límite inferior, con estos pesos bajos como empresa no estaríamos cumpliendo con el 
cliente, por tal razón se generarían reclamos por no cumplir el peso. También se aprecia que el ${rango_alto}% 
de los sacos se encuentran con el peso arriba del límite superior, con estos pesos es una manera 
de generar pérdidas de producto terminado en la etapa de ensacado. El ${rango}% de los sacos restantes, 
cumplen con el peso requerido a la carta control, ya que se encuentran dentro del rango 
establecido. 
En los resultados estadísticos se obtuvo una media aritmética de ${media2}, mediana de ${mediana} y una 
Desviación Estándar de ${desviacionEstandar} con respecto a la media, con un Coeficiente de Variación de ${coeficienteVariacion}. 
`;


    pdf.text(texto, 25, 85, { maxWidth: 170, align: 'justify' });

    const img = new Image();


    if (data[0].nombre_usuario === "Ramiro Jose Merida Mas") {
        img.src = firmaRamiro;

        img.onload = () => {
            // Validamos que la imagen se haya cargado correctamente
            if (img.complete && img.naturalWidth !== 0) {
                pdf.addImage(img, 'PNG', 60, 200, 100, 40);
            } else {
                console.warn("La imagen no se cargó correctamente.");
            }

            pdf.save('reporte_ensacado.pdf');
        };

        img.onerror = () => {
            console.error("Error al cargar la firma de Ramiro Merida.");
            pdf.save('reporte_ensacado.pdf');
        };
    } else if (data[0].nombre_usuario === "Carlos Enrique Ajpop Mejia") {
        // Si no es Ramiro, igual guardamos el PDF sin firma
        img.src = firmaCarlos;

        img.onload = () => {
            // Validamos que la imagen se haya cargado correctamente
            if (img.complete && img.naturalWidth !== 0) {
                pdf.addImage(img, 'PNG', 60, 200, 100, 40);
            } else {
                console.warn("La imagen no se cargó correctamente.");
            }

            pdf.save('reporte_ensacado.pdf');
        };

        img.onerror = () => {
            console.error("Error al cargar la firma de Carlos Ajpop.");
            pdf.save('reporte_ensacado.pdf');
        };
    } else if (data[0].nombre_usuario === "Jorge Mario Martinez Maldonado") {
        img.src = firmaJorge;

        img.onload = () => {
            // Validamos que la imagen se haya cargado correctamente
            if (img.complete && img.naturalWidth !== 0) {
                pdf.addImage(img, 'PNG', 60, 200, 100, 40);
            } else {
                console.warn("La imagen no se cargó correctamente.");
            }

            pdf.save('reporte_ensacado.pdf');
        };

       } else if (data[0].nombre_usuario === "Angely Michelle Villagrán Donis") {
        img.src = firmaAngely;

        img.onload = () => {
            // Validamos que la imagen se haya cargado correctamente
            if (img.complete && img.naturalWidth !== 0) {
                pdf.addImage(img, 'PNG', 60, 200, 100, 40);
            } else {
                console.warn("La imagen no se cargó correctamente.");
            }

            pdf.save('reporte_ensacado.pdf');
        }; 

        img.onerror = () => {
            console.error("Error al cargar la firma de Jorge Martinez.");
            pdf.save('reporte_ensacado.pdf');
        };


    } else {
        pdf.save('reporte_ensacado.pdf');
    }


};